import React from 'react';
import { NotTranslated, T, whenTPlainTextKey } from '.';

interface Props {
  text: string;
}

const TranslatableTextDisplay: React.FC<Props> = ({ text }) => {
  return whenTPlainTextKey(text)
    .map((text) => <T kind={text} />)
    .getOrElse(() => <NotTranslated text={text} />);
};

export default TranslatableTextDisplay;
